var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_black_24dp",
    transform: "translate(0.339 0.339)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150115",
    "data-name": "Rectangle 150115",
    width: 148,
    height: 148,
    transform: "translate(-0.339 -0.339)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "error_outline_black_24dp_1_",
    "data-name": "error_outline_black_24dp (1)",
    d: "M62,32a6.018,6.018,0,0,1,6,6V62a6,6,0,0,1-12,0V38A6.018,6.018,0,0,1,62,32ZM61.94,2A60,60,0,1,0,122,62,59.971,59.971,0,0,0,61.94,2ZM62,110a48,48,0,1,1,48-48A47.987,47.987,0,0,1,62,110Zm6-18H56V80H68Z",
    transform: "translate(11.661 11.661)",
    fill: "#ba1a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.a0edb82c7523faab187249cb2615d34d.svg";
export { ForwardRef as ReactComponent };